import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Initial = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/input");
  };

  const desview = () => {
    navigate("/encryptionview", {
      state: {
        hexplaintext,
        hexkey,
        AllexcryptionResults,
        binary64bitValueSwapped,
        cipherhex,
        bytes,
        inputValue,
        KeyValue,
        splitted_array,
        allResults,
        // finalEncryptedValue,
      },
    });
  };

  const location = useLocation();
  const inputValue = location.state.inputValue;
  const KeyValue = location.state.KeyValue;
  const hexplaintext = location.state.hexplaintext;
  const hexkey = location.state.hexkey;
  let dupInputValue = inputValue;
  let hexInputValue = "";
  let binaryInputValue = "";

  let dupKeyValue = KeyValue;
  let hexKeyValue = "";
  let binaryKeyValue = "";

  if (dupKeyValue.length < 8) {
    while (dupKeyValue.length < 8) {
      dupKeyValue += "\0";
    }
  }

  for (let i = 0; i < dupKeyValue.length; i++) {
    const hex = dupKeyValue
      .charCodeAt(i)
      .toString(16)
      .toUpperCase()
      .concat(",");
    const bin = dupKeyValue.charCodeAt(i).toString(2).concat(",");
    hexKeyValue += hex.padStart(2, "0");
    hexKeyValue = hexKeyValue.split(",");
    binaryKeyValue += bin.padStart(9, "0");
    binaryKeyValue = binaryKeyValue.split(",");
  }

  binaryKeyValue.pop();
  hexKeyValue.pop();

  let binaryKeyValue56 = "";
  for (let i = 0; i < binaryKeyValue.length; i++) {
    console.log(binaryKeyValue[i].slice(0, 7));
    binaryKeyValue56 += binaryKeyValue[i].slice(0, 7) + ",";
  }
  binaryKeyValue56 = binaryKeyValue56.split(",");
  binaryKeyValue56.pop();

  if (dupInputValue.length < 8) {
    while (dupInputValue.length < 8) {
      dupInputValue += "\0";
    }
  }

  for (let i = 0; i < dupInputValue.length; i++) {
    const hex = dupInputValue
      .charCodeAt(i)
      .toString(16)
      .toUpperCase()
      .concat(",");
    const bin = dupInputValue.charCodeAt(i).toString(2).concat(",");
    hexInputValue += hex.padStart(2, "0");
    hexInputValue = hexInputValue.split(",");
    binaryInputValue += bin.padStart(9, "0");
    binaryInputValue = binaryInputValue.split(",");
  }

  binaryInputValue.pop();
  hexInputValue.pop();
  console.log(binaryInputValue);
  function initialPermutation(plaintext) {
    // Define the initial permutation table (IP)
    const ipTable = [
      58, 50, 42, 34, 26, 18, 10, 2, 60, 52, 44, 36, 28, 20, 12, 4, 62, 54, 46,
      38, 30, 22, 14, 6, 64, 56, 48, 40, 32, 24, 16, 8, 57, 49, 41, 33, 25, 17,
      9, 1, 59, 51, 43, 35, 27, 19, 11, 3, 61, 53, 45, 37, 29, 21, 13, 5, 63,
      55, 47, 39, 31, 23, 15, 7,
    ];

    // Check if the plaintext array is valid
    if (plaintext.length !== 8 || plaintext.some((elem) => elem.length !== 8)) {
      throw new Error(
        "Plaintext array must contain 8 elements, each with 8 bits."
      );
    }

    // Initialize the result array
    const result = [];

    // Convert the plaintext array to a single binary string
    const binaryPlaintext = plaintext.join("");

    // Apply the initial permutation
    for (let i = 0; i < 64; i++) {
      const targetBitIndex = ipTable[i] - 1;
      result.push(binaryPlaintext.charAt(targetBitIndex));
    }

    return result;
  }

  function groupToBytes(groupedArray) {
    if (
      groupedArray.length !== 64 ||
      groupedArray.some((elem) => elem.length !== 1)
    ) {
      throw new Error("Input array must contain 64 elements, each with 1 bit.");
    }

    const bytesArray = [];
    for (let i = 0; i < 64; i += 8) {
      const byte = groupedArray.slice(i, i + 8).join("");
      bytesArray.push(byte);
    }

    return bytesArray;
  }

  // Example usage:
  const initialPermuted = initialPermutation(binaryInputValue);
  const bytes = groupToBytes(initialPermuted);

  console.log(binaryInputValue);

  const splitInto28 = (array) => {
    let binaryString = arrayToString(array);

    const OrderForC = [
      57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43,
      35, 27, 19, 11, 3, 60, 52, 44, 36,
    ];

    const OrderForD = [
      63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45,
      37, 29, 21, 13, 5, 28, 20, 12, 4,
    ];

    let binary28bit_c = [];
    for (let i = 0; i < 28; i++) {
      binary28bit_c[i] = binaryString[OrderForC[i] - 1];
    }

    let binary28bit_d = [];
    for (let i = 0; i < 28; i++) {
      binary28bit_d[i] = binaryString[OrderForD[i] - 1];
    }

    return [binary28bit_c, binary28bit_d];
  };

  const arrayToString = (array) => {
    let string = "";
    for (let i = 0; i < array.length; i++) {
      string += array[i];
    }
    return string;
  };

  const stringToArray = (string) => {
    const chunks = [];
    for (let i = 0; i < 28; i += 7) {
      chunks.push(string.substring(i, i + 7));
    }
    return chunks;
  };

  const leftShift = (round, array) => {
    let c = array[0];
    let d = array[1];
    let shiftedCD = [];
    if (round === 1 || round === 2 || round === 9 || round === 16) {
      let shiftAmount = 1;
      let shiftedC =
        arrayToString(c).slice(shiftAmount) +
        arrayToString(c).slice(0, shiftAmount);
      let shiftedD =
        arrayToString(d).slice(shiftAmount) +
        arrayToString(d).slice(0, shiftAmount);
      shiftedCD.push(stringToArray(shiftedC), stringToArray(shiftedD));
      return shiftedCD;
    } else {
      let shiftAmount = 2;
      let shiftedC =
        arrayToString(c).slice(shiftAmount) +
        arrayToString(c).slice(0, shiftAmount);
      let shiftedD =
        arrayToString(d).slice(shiftAmount) +
        arrayToString(d).slice(0, shiftAmount);
      shiftedCD.push(stringToArray(shiftedC), stringToArray(shiftedD));
      return shiftedCD;
    }
  };

  const compPermute = (array) => {
    let compPermuteArray = [];
    let bigString = arrayToString(array[0].concat(array[1]));
    const compPermuteOrder = [
      14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7,
      27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39,
      56, 34, 53, 46, 42, 50, 36, 29, 32,
    ];
    for (let i = 0; i < 48; i++) {
      compPermuteArray[i] = bigString[compPermuteOrder[i] - 1];
    }
    return compPermuteArray;
  };

  const crctFormetForSplited = (array) => {
    const outputArray = [];
    for (const str of array) {
      for (const char of str) {
        outputArray.push(char);
      }
    }
    return outputArray;
  };

  const compute = (binaryKeyValue, round) => {
    if (round === 1) {
      let splitedArray = splitInto28(binaryKeyValue);

      let shiftedArray = leftShift(round, splitedArray);

      let compPermuteArray = compPermute(shiftedArray);

      return [splitedArray, shiftedArray, compPermuteArray];
    } else {
      let splitedArray = [
        crctFormetForSplited(binaryKeyValue[0]),
        crctFormetForSplited(binaryKeyValue[1]),
      ];

      let shiftedArray = leftShift(round, splitedArray);
      //console.log(shiftedArray);
      let compPermuteArray = compPermute(shiftedArray);
      //console.log(compPermuteArray);
      return [splitedArray, shiftedArray, compPermuteArray];
    }
  };

  const keyGeneration = () => {
    let allResults = [];
    let currInput = binaryKeyValue;

    for (let round = 1; round < 17; round++) {
      let oneRoundResult = compute(currInput, round);
      //console.log(compute(currInput , round));
      currInput = oneRoundResult[1];
      allResults.push(oneRoundResult);
    }
    return allResults;
  };

  let allResults = keyGeneration();

  //function to divide the IP array into 2 halves (32-bit halves)
  function split_into_32bits(bytes) {
    let left_half = bytes.slice(0, 4);
    let right_half = bytes.slice(4, 8);
    return [left_half, right_half];
  }

  // splitted_array has the 2 halves of 64 bit IP array
  const splitted_array = split_into_32bits(bytes);
  //console.log(splitted_array)

  //expansion permutation function expands the 32 bit-havels into 48 bits
  function expansion_permutation(right_half) {
    const exp_perm_table = [
      32, 1, 2, 3, 4, 5, 4, 5, 6, 7, 8, 9, 8, 9, 10, 11, 12, 13, 12, 13, 14, 15,
      16, 17, 16, 17, 18, 19, 20, 21, 20, 21, 22, 23, 24, 25, 24, 25, 26, 27,
      28, 29, 28, 29, 30, 31, 32, 1,
    ];

    let i = 0;
    let expanded_array = [];
    let flat_right_half = "";
    for (i = 0; i < 4; i++) {
      flat_right_half = flat_right_half + right_half[i];
    }

    for (i = 0; i < 48; i++) {
      expanded_array.push(flat_right_half[exp_perm_table[i] - 1]);
    }
    return expanded_array;
  }

  // groupTo48Bytes group the 48 bits into six 8 bits
  function groupTo48Bytes(groupedArray) {
    if (
      groupedArray.length !== 48 ||
      groupedArray.some((elem) => elem.length !== 1)
    ) {
      throw new Error("Input array must contain 48 elements, each with 1 bit.");
    }

    const bytesArray = [];
    for (let i = 0; i < 48; i += 8) {
      const byte = groupedArray.slice(i, i + 8).join("");
      bytesArray.push(byte);
    }

    return bytesArray;
  }

  // groupTo64Bytes group the 64 bits into eight 8 bits
  function groupTo64Bytes(groupedArray) {
    // if (groupedArray.length !== 48 || groupedArray.some(elem => elem.length !== 1)) {
    //   throw new Error('Input array must contain 48 elements, each with 1 bit.');
    // }

    const bytesArray = [];
    for (let i = 0; i < 64; i += 8) {
      const byte = groupedArray.slice(i, i + 8).join("");
      bytesArray.push(byte);
    }

    return bytesArray;
  }

  // groupTo48Bytes group the 48 bits into eight 6 bits
  function group48BytesTo6(groupedArray) {
    // if (groupedArray.length !== 48 || groupedArray.some(elem => elem.length !== 1)) {
    //   throw new Error('Input array must contain 48 elements, each with 1 bit.');
    // }

    const bytesArray = [];
    for (let i = 0; i < 48; i += 6) {
      const byte = groupedArray.slice(i, i + 6).join("");
      bytesArray.push(byte);
    }

    return bytesArray;
  }

  // example usage
  //const expanded_array = groupTo48Bytes(expansion_permutation(splitted_array[1]));
  //console.log(expanded_array)

  // xor48bit performs xor between 2 48 bit inputs

  function group32BytesTo8(groupedArray) {
    const bytesArray = [];
    for (let i = 0; i < 32; i += 8) {
      const byte = groupedArray.slice(i, i + 8).join("");
      bytesArray.push(byte);
    }

    return bytesArray;
  }

  function xor48bit(RightHalf48Bit, Key48Bit) {
    //generates a flattened array
    // console.log(Key48Bit)
    // console.log(RightHalf48Bit)
    const flattenedinput1 = [];
    for (let i = 0; i < RightHalf48Bit.length; i++) {
      for (let j = 0; j < RightHalf48Bit[i].length; j++) {
        flattenedinput1.push(RightHalf48Bit[i][j]);
      }
    }

    const result = [];

    for (let i = 0; i < 48; i++) {
      const bit1 = flattenedinput1[i];
      const bit2 = Key48Bit[i];
      result.push(bit1 ^ bit2); // XOR operation
    }

    return result;
  }

  // Sbox will convert the 48 bit input back to 32 bits
  function Sbox(XorArray) {
    let Sbox32BitArray = [];
    // sbox array has all the s-boxes
    const sbox = [
      [
        [14, 4, 13, 1, 2, 15, 11, 8, 3, 10, 6, 12, 5, 9, 0, 7],
        [0, 15, 7, 4, 14, 2, 13, 1, 10, 6, 12, 11, 9, 5, 3, 8],
        [4, 1, 14, 8, 13, 6, 2, 11, 15, 12, 9, 7, 3, 10, 5, 0],
        [15, 12, 8, 2, 4, 9, 1, 7, 5, 11, 3, 14, 10, 0, 6, 13],
      ], //sbox1

      [
        [15, 1, 8, 14, 6, 11, 3, 4, 9, 7, 2, 13, 12, 0, 5, 10],
        [3, 13, 4, 7, 15, 2, 8, 14, 12, 0, 1, 10, 6, 9, 11, 5],
        [0, 14, 7, 11, 10, 4, 13, 1, 5, 8, 12, 6, 9, 3, 2, 15],
        [13, 8, 10, 1, 3, 15, 4, 2, 11, 6, 7, 12, 0, 5, 14, 9],
      ], //sbox2

      [
        [10, 0, 9, 14, 6, 3, 15, 5, 1, 13, 12, 7, 11, 4, 2, 8],
        [13, 7, 0, 9, 3, 4, 6, 10, 2, 8, 5, 14, 12, 11, 15, 1],
        [13, 6, 4, 9, 8, 15, 3, 0, 11, 1, 2, 12, 5, 10, 14, 7],
        [1, 10, 13, 0, 6, 9, 8, 7, 4, 15, 14, 3, 11, 5, 2, 12],
      ], //sbox3

      [
        [7, 13, 14, 3, 0, 6, 9, 10, 1, 2, 8, 5, 11, 12, 4, 15],
        [13, 8, 11, 5, 6, 15, 0, 3, 4, 7, 2, 12, 1, 10, 14, 9],
        [10, 6, 9, 0, 12, 11, 7, 13, 15, 1, 3, 14, 5, 2, 8, 4],
        [3, 15, 0, 6, 10, 1, 13, 8, 9, 4, 5, 11, 12, 7, 2, 14],
      ], //sbox4

      [
        [2, 12, 4, 1, 7, 10, 11, 6, 8, 5, 3, 15, 13, 0, 14, 9],
        [14, 11, 2, 12, 4, 7, 13, 1, 5, 0, 15, 10, 3, 9, 8, 6],
        [4, 2, 1, 11, 10, 13, 7, 8, 15, 9, 12, 5, 6, 3, 0, 14],
        [11, 8, 12, 7, 1, 14, 2, 13, 6, 15, 0, 9, 10, 4, 5, 3],
      ], //sbox5

      [
        [12, 1, 10, 15, 9, 2, 6, 8, 0, 13, 3, 4, 14, 7, 5, 11],
        [10, 15, 4, 2, 7, 12, 9, 5, 6, 1, 13, 14, 0, 11, 3, 8],
        [9, 14, 15, 5, 2, 8, 12, 3, 7, 0, 4, 10, 1, 13, 11, 6],
        [4, 3, 2, 12, 9, 5, 15, 10, 11, 14, 1, 7, 6, 0, 8, 13],
      ], //sbox6

      [
        [4, 11, 2, 14, 15, 0, 8, 13, 3, 12, 9, 7, 5, 10, 6, 1],
        [13, 0, 11, 7, 4, 9, 1, 10, 14, 3, 5, 12, 2, 15, 8, 6],
        [1, 4, 11, 13, 12, 3, 7, 14, 10, 15, 6, 8, 0, 5, 9, 2],
        [6, 11, 13, 8, 1, 4, 10, 7, 9, 5, 0, 15, 14, 2, 3, 12],
      ], //sbox7

      [
        [13, 2, 8, 4, 6, 15, 11, 1, 10, 9, 3, 14, 5, 0, 12, 7],
        [1, 15, 13, 8, 10, 3, 7, 4, 12, 5, 6, 11, 0, 14, 9, 2],
        [7, 11, 4, 1, 9, 12, 14, 2, 0, 6, 10, 13, 15, 3, 5, 8],
        [2, 1, 14, 7, 4, 10, 8, 13, 15, 12, 9, 0, 3, 5, 6, 11],
      ], //sbox8
    ];

    // grouping the 48 bits into eight 6 bits
    //console.log(XorArray)
    const xor48Bit = group48BytesTo6(XorArray);

    for (let i = 0; i < 8; i++) {
      let Bytes = xor48Bit[i];
      let sboxi = sbox[i];
      let row = parseInt(Bytes[0] + Bytes[5], 2);
      let column = parseInt(Bytes.slice(1, 5), 2);
      // console.log(row)
      //console.log(column)
      let sboxValue = sboxi[row][column].toString(2);
      while (sboxValue.length < 4) {
        sboxValue = "0" + sboxValue;
      }
      Sbox32BitArray.push(sboxValue);
    }

    // flattens the output
    let flatSbox32BitArray = Sbox32BitArray.join("");
    Sbox32BitArray = Array.from(flatSbox32BitArray);

    return Sbox32BitArray;
  }

  // permutes the output from Sbox
  function Pbox(SboxOutput) {
    const pbox = [
      16, 7, 20, 21, 29, 12, 28, 17, 1, 15, 23, 26, 5, 18, 31, 10, 2, 8, 24, 14,
      32, 27, 3, 9, 19, 13, 30, 6, 22, 11, 4, 25,
    ];

    let pboxOutput = [];
    for (let i = 0; i < 32; i++) {
      pboxOutput.push(SboxOutput[pbox[i] - 1]);
    }
    return pboxOutput;
    // output of p box is flattend for now might have to change in future !!!
  }

  //performs xor between 2 32 bit inputs
  function xor32bit(left_half, manglerOutput) {
    let flat_left_half = [];
    for (let i = 0; i < 4; i++) {
      let bits = left_half[i];
      for (let j = 0; j < 8; j++) {
        flat_left_half.push(bits[j]);
      }
    }

    const resultArray = [];
    for (let i = 0; i < 32; i++) {
      resultArray.push(flat_left_half[i] ^ manglerOutput[i]);
    }

    return resultArray;
  }

  //the mangler function will perform the expansion permutation , then xors the 48 bit output
  //with the 48 bit key then passes it through the s-box to make 32 bit again and finally pass
  //it through the p bot to permute it.

  function mangler(RightHalf, Key48Bit) {
    const expandedArray48Bits = groupTo48Bytes(
      expansion_permutation(RightHalf)
    );
    let XorArray = xor48bit(expandedArray48Bits, Key48Bit);
    let SboxOutput = Sbox(XorArray);
    let PboxOutput = Pbox(SboxOutput);
    return [SboxOutput, PboxOutput, expandedArray48Bits];
  }

  //performs the 16 rounds of encryption and returns the resuts of
  //new 64 bit
  //sbox values
  //pbox values

  function desEncrypt(splitedArray) {
    let excryptionResults = [];
    let SboxOutputs = [];
    let PboxOutputs = [];
    let expansionPermOutputs = [];
    let currentSplitedArray = splitedArray;
    for (let i = 0; i < 16; i++) {
      let newLeftHalf = currentSplitedArray[1];
      let manglerOutput = mangler(currentSplitedArray[1], allResults[i][2]);
      let newRightHalf = xor32bit(currentSplitedArray[0], manglerOutput[1]);
      newRightHalf = group32BytesTo8(newRightHalf);
      currentSplitedArray[0] = newLeftHalf;
      currentSplitedArray[1] = newRightHalf;

      SboxOutputs.push(manglerOutput[0]);
      PboxOutputs.push(manglerOutput[1]);
      excryptionResults.push([newLeftHalf, newRightHalf]);
      expansionPermOutputs.push(manglerOutput[2]);
    }
    return [SboxOutputs, PboxOutputs, excryptionResults, expansionPermOutputs];
  }
  let AllexcryptionResults = desEncrypt(splitted_array);
  const SboxOutputs = AllexcryptionResults[0]; //has all the S-box values
  const PboxOutputs = AllexcryptionResults[1]; //has all the P-box values
  const excryptionResults = AllexcryptionResults[2]; //has all the 64 values
  const expansionPermOutputs = AllexcryptionResults[3]; //has all expansion permutation values
  //console.log(excryptionResults)

  // Performs a 32 bit swap
  function _32bitSwap(binary64bitValue) {
    let binary64bitValueSwapped = [];
    binary64bitValueSwapped[0] = binary64bitValue[1];
    binary64bitValueSwapped[1] = binary64bitValue[0];
    return binary64bitValueSwapped;
  }

  //performs the final permutation

  function finalPerm(binary64bitValueSwapped) {
    let flatBinary64bitValueSwapped = [];
    binary64bitValueSwapped = [].concat(...binary64bitValueSwapped);
    for (let i = 0; i < 8; i++) {
      let ele = binary64bitValueSwapped[i];
      for (let j = 0; j < 8; j++) {
        flatBinary64bitValueSwapped.push(ele[j]);
      }
    }

    let finalPerm = [
      40, 8, 48, 16, 56, 24, 64, 32, 39, 7, 47, 15, 55, 23, 63, 31, 38, 6, 46,
      14, 54, 22, 62, 30, 37, 5, 45, 13, 53, 21, 61, 29, 36, 4, 44, 12, 52, 20,
      60, 28, 35, 3, 43, 11, 51, 19, 59, 27, 34, 2, 42, 10, 50, 18, 58, 26, 33,
      1, 41, 9, 49, 17, 57, 25,
    ];

    let finalEncryptedValue = [];
    for (let i = 0; i < 64; i++) {
      finalEncryptedValue.push(flatBinary64bitValueSwapped[finalPerm[i] - 1]);
    }
    return groupTo64Bytes(finalEncryptedValue);
  }

  const binaryToHexadecimal = (binaryArray) => {
    const binaryString = binaryArray.join("");

    if (binaryString.length !== 64) {
      throw new Error(
        "Each element in the array must be an 8-bit binary string."
      );
    }

    let hexadecimalResult = "";

    for (let i = 0; i < 8; i++) {
      const chunk = binaryString.slice(i * 8, (i + 1) * 8);
      const hexDigit = parseInt(chunk, 2).toString(16).toUpperCase();
      hexadecimalResult += hexDigit;
      if (i < 7) {
        hexadecimalResult += " "; // Add a space between every two characters
      }
    }

    return hexadecimalResult;
  };
  const hexbytes = binaryToHexadecimal(bytes);

  const binary64bitValueSwapped = _32bitSwap(excryptionResults[15]); // after 32 bit swap
  const finalEncryptedValue = finalPerm(binary64bitValueSwapped); // final Ciphertext !!
  const cipherhex = binaryToHexadecimal(finalEncryptedValue); //Hex Ciphertext

  console.log(finalEncryptedValue);

  return (
    <>
     <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>This page highlights the encryption process. The plaintext and the key are used to produce the desired cipher text.
        <br></br><br></br>
        For detailed explaination about various steps involved in DES Encryption please press the <b>view</b> button
      </p>
    </div>
      <div className="input-container">
        <div className="flex flex-col items-center">
         
          <div className="grid grid-cols-3 gap-4 justify-center items-center h-screen">
            <div>
              <p className="text-xl">Plaintext</p>

              <div class="group relative">
                <div class="hidden absolute left-0 -ml-64 p-3 bg-gray-700 text-white w-90 rounded shadow group-hover:block whitespace-nowrap">
                  Hexadecimal form of {dupInputValue}
                </div>
                <div class="border-solid border-black border-2 p-1 m-1">
                  <p>{hexplaintext}</p>
                </div>
              </div>

              <div className=" pl-24 pb-5">
                <svg
                  width="240"
                  height="70"
                  viewBox="0 0 297 106"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line x1="1" y1="98" x2="1" stroke="black" stroke-width="2" />
                  <path
                    d="M296.708 98.4725C297.098 98.082 297.098 97.4488 296.708 97.0583L290.344 90.6943C289.953 90.3038 289.32 90.3038 288.929 90.6943C288.539 91.0848 288.539 91.718 288.929 92.1085L294.586 97.7654L288.929 103.422C288.539 103.813 288.539 104.446 288.929 104.836C289.32 105.227 289.953 105.227 290.344 104.836L296.708 98.4725ZM2 98.7654H296V96.7654H2V98.7654Z"
                    fill="black"
                  />
                </svg>
              </div>

              <div className=" pl-24 pt-5">
                <svg
                  width="240"
                  height="70"
                  viewBox="0 0 297 106"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="1"
                    y1="106"
                    x2="1"
                    y2="8"
                    stroke="black"
                    stroke-width="2"
                  />
                  <path
                    d="M296.708 8.47249C297.098 8.08196 297.098 7.4488 296.708 7.05827L290.344 0.694313C289.953 0.303789 289.32 0.303789 288.929 0.694313C288.539 1.08484 288.539 1.718 288.929 2.10853L294.586 7.76538L288.929 13.4222C288.539 13.8128 288.539 14.4459 288.929 14.8364C289.32 15.227 289.953 15.227 290.344 14.8364L296.708 8.47249ZM2 8.76538H296V6.76538H2V8.76538Z"
                    fill="black"
                  />
                </svg>
              </div>

              <div class="group relative">
                <div class="hidden absolute left-0 -ml-64 p-3 bg-gray-700 text-white w-90 rounded shadow group-hover:block whitespace-nowrap">
                  Hexadecimal form of {dupKeyValue}
                </div>
                <div class="border-solid border-black border-2 p-1 m-1">
                  <p>{hexkey}</p>
                </div>
              </div>

              <p className="text-xl">Key</p>
            </div>
            <div className="grid grid-cols-2 justify-center items-center">
              <div className="bg-blue-700 p-4 rounded-lg shadow-lg text-white">
                <p className="text-lg font-semibold">DES Encryption</p>
                <button
                  onClick={desview}
                  className="bg-white text-blue-500 px-4 py-2 mt-2 rounded hover:bg-blue-200 hover:text-blue-700 transition duration-300"
                >
                  View
                </button>
              </div>
              <div>
                <svg
                  width="160"
                  height="20"
                  viewBox="0 0 129 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M128.002 8.98779L113.002 0.327539V17.648L128.002 8.98779ZM0.998047 10.4878H114.502V7.48779H0.998047V10.4878Z"
                    fill="black"
                  />
                </svg>
              </div>
            </div>
            <div>
              <p className="text-xl">Cipher Text</p>
              <div className="border-solid border-black border-2 p-1 m-1">
                <p>{cipherhex}</p>
              </div>
            </div>
          </div>

          <div class="button-holder">
            <div class="prev-button" onClick={firstpage}>
              PREVIOUS
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Initial;
